(() => {
	const track = (event, properties = {}) => {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({ event, ...properties });
	};

	const prefillBulkQuote = () => {
		const form = document.querySelector('form.tt-bulk-quote-form');
		if (!form) return;

		const params = new URLSearchParams(window.location.search);
		const product = params.get('product');
		const variant = params.get('variant');
		const quantity = params.get('quantity');
		const zip = params.get('zip');
		const productInput = form.querySelector('#ContactForm-product');

		if (productInput && product) {
			productInput.value = variant ? `${product} — ${variant}` : product;
		}
		if (quantity && form.querySelector('#ContactForm-quantity')) {
			form.querySelector('#ContactForm-quantity').value = quantity;
		}
		if (zip && form.querySelector('#ContactForm-zip')) {
			form.querySelector('#ContactForm-zip').value = zip;
		}
	};

	document.addEventListener('DOMContentLoaded', prefillBulkQuote);

	document.addEventListener('cart:item-add', (event) => {
		track('tt_add_to_cart', {
			context: event.detail?.context || 'unknown',
			variant_id: event.detail?.items?.[0]?.variant_id || event.detail?.items?.[0]?.id || null,
		});
	});

	document.addEventListener('tt:shipping-estimate', (event) => {
		track('tt_shipping_estimate', {
			status: event.detail?.status || 'unknown',
			rate_count: event.detail?.rateCount || 0,
			free_rate_available: Boolean(event.detail?.freeRateAvailable),
		});
	});

	document.addEventListener('change', (event) => {
		if (!event.target.matches('variant-selects select, variant-radios input')) return;
		track('tt_variant_selected', {
			option_name: event.target.name || null,
			product_path: window.location.pathname,
		});
	});

	document.addEventListener('submit', (event) => {
		if (event.target.matches('form.tt-bulk-quote-form')) {
			track('tt_bulk_quote_submit', { source: 'bulk_quote_page' });
		}
		if (event.target.matches('form[data-reorder-form]')) {
			track('tt_reorder_submit', { item_count: Number(event.target.dataset.itemCount || 0) });
		}
		if (event.target.matches('form[action*="/search"]')) {
			track('tt_site_search', { source: 'storefront' });
		}
	});

	document.addEventListener('click', (event) => {
		const firstOrderLink = event.target.closest('[data-first-order-cta]');
		if (firstOrderLink) track('tt_first_order_offer_click', { cart_value: Number(firstOrderLink.dataset.cartValue || 0) });

		const quoteLink = event.target.closest('[data-bulk-quote-link]');
		if (quoteLink) track('tt_bulk_quote_click', { source: quoteLink.dataset.quoteSource || 'unknown' });

		const applicationLink = event.target.closest('.tt-application-grid a');
		if (applicationLink) track('tt_application_click', { label: applicationLink.textContent.trim() });
	});
})();
